import React, {PropTypes} from 'react';
import FloatingActionButton from 'material-ui/FloatingActionButton';



class ChatterHome extends React.Component {

    constructor() {
      super();
      this.state={months: [],active: 0}
    }
    componentDidMount()
    {

      let months=[
        "February 2016",
        "March 2016",
        "April 2016",
        "May 2016",
        "June 2016",
        "July 2016",
        "August 2016",
        "September 2016",
        "October 2016",
        "November 2016",
        "December 2016",
        "January 2017",
        "February March 2017",
        "March April 2017",
        "May June 2017",
        "Jan 2018",
        "Aug 2018",
        "Jan 2019",
        "June_2019",
        "Jan_2020",
        "June_2020"
      ];
      this.setState({months: months,active: months.length-1});
      this.props.changeBanner("Quikr Chatter - " + months[months.length-1]);
    }

    render() {
      let reachedLast = false;
      let reachedFirst = false;
      if(this.state.active == this.state.months.length-1)
        reachedLast=true;
      if(this.state.active == 0)
        reachedFirst = true;
        return (
          <div className="col-md-12" style={{height: '100%',width: '100%'}}>
          <div className="col-md-12">
            <div style={{width: '100%',margin: "0 auto",marginBottom: '10px',marginTop: '10px'}}>


              </div>
            </div>
            <div className="col-md-1">
              <FloatingActionButton
                disabled={reachedFirst}
                onClick={()=>{
                  if(this.state.active-1 >= 0) {
                    this.props.changeBanner("Quikr Chatter - " + this.state.months[this.state.active-1]);
                    this.setState({active: this.state.active - 1})
                  }

                }}
                iconClassName="fa fa-angle-left fa-5x growLots" />

            </div>
            <div className="col-md-10"> <iframe style={{height: '80vh',width: '100%'}} width="100%" src={"/public/chatter/"+this.state.months[this.state.active]+".html"} /></div>
            <div className="col-md-1">
              <FloatingActionButton
                disabled={reachedLast}
                onClick={()=>{
                  if(this.state.active+1 < this.state.months.length) {
                    this.props.changeBanner("Quikr Chatter - " + this.state.months[this.state.active+1]);
                    this.setState({active: this.state.active + 1})
                  }
                }}
                style={{float: 'right',zIndex: '10'}}  iconClassName="fa fa-angle-right fa-5x growLots" />
            </div>


          </div>


        );
    }
}

ChatterHome.propTypes = {};

export default ChatterHome;





/** WEBPACK FOOTER **
 ** ./src/feature/announcements/ChatterHome.js
 **/